import React from "react";
import { NavLink } from "react-router-dom";
import integratedLeadCapture from "../../assets/images/homePage/integrated_lead_capture.png";

const BookingCapture = () => {
  return (
    <section className="tw-py-20 lg:tw-py-24 tw-bg-white tw-border-t tw-border-solid tw-border-slate-100">
      <div className="tw-max-w-7xl tw-mx-auto tw-px-4 sm:tw-px-6 lg:tw-px-8">
        
        {/* Layout Grid */}
        <div className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-12 tw-gap-12 tw-items-center">
          
          {/* Left Column: Image */}
          <div className="lg:tw-col-span-5 tw-flex tw-justify-center">
            <div className="tw-relative">
              <div className="hero-img-glow tw-opacity-35 tw-blur-2xl" />
              <img
                src={integratedLeadCapture}
                alt="Capture All Your Hotel & Resort Booking Inquiries"
                className="tw-max-w-full tw-h-auto tw-rounded-3xl img-shadow-indigo"
                loading="lazy"
              />
            </div>
          </div>

          {/* Right Column: Text Content */}
          <div className="lg:tw-col-span-7 tw-text-left">
            <h2 className="tw-text-2xl sm:tw-text-3xl tw-font-extrabold tw-text-slate-900 tw-leading-tight tw-mb-6">
              Capture All Your Hotel & Resort Booking Inquiries, <br /> No Matter Where They Come From.
            </h2>
            <p className="tw-text-base tw-text-slate-600 tw-leading-relaxed tw-mb-4">
              Capture leads directly from popular booking sites like MakeMyTrip, TripAdvisor, Hotels.com, and Booking.com.
            </p>
            <p className="tw-text-base tw-text-slate-600 tw-leading-relaxed tw-mb-8">
              BeyondLeadz automatically integrates these leads into your marketing database, enabling you to follow up with personalized offers and promotions.
            </p>

            <NavLink
              to="/signup"
              className="tw-inline-flex tw-items-center tw-justify-center tw-px-8 tw-py-3.5 tw-bg-[#5D44FF] hover:tw-bg-indigo-600 tw-text-white tw-font-bold tw-text-sm tw-rounded-xl tw-shadow-lg tw-shadow-indigo-500/20 tw-transition-all hover:tw-scale-[1.03]"
            >
              Try Now
            </NavLink>
          </div>

        </div>

      </div>
    </section>
  );
};

export default BookingCapture;
